import type {OffersSearch} from "./-types";
import type {ListCustomerOffersSearchInput} from "@project/application/sales/customer-offers";
import type {QueryClient} from "@tanstack/react-query";
import type {AnyContext, Register, ResolveParams, SearchSchemaInput} from "@tanstack/react-router";
import {listCustomerOffersQueryOptions} from "@project/application/sales/customer-offers";
import {AppErrorBoundary} from "@project/layouts";
import {createFileRoute} from "@tanstack/react-router";
import {OffersPage} from "./-page/offers.page";
import {OffersPending} from "./-page/offers.pending";
import {offersSearchSchema} from "./-types";

export type {OffersSearch} from "./-types";
const validateOffersSearch = (
  search: ListCustomerOffersSearchInput & SearchSchemaInput,
): OffersSearch => offersSearchSchema.parse(search);
const offersLoaderDeps = ({search}: {search: OffersSearch}) => search;
async function offersLoader({
  context: {queryClient},
  deps,
  cause,
}: {
  context: {queryClient: QueryClient};
  deps: OffersSearch;
  cause: "enter" | "preload" | "stay";
}) {
  if (cause === "enter") return queryClient.ensureQueryData(listCustomerOffersQueryOptions(deps));
  void queryClient.prefetchQuery(listCustomerOffersQueryOptions(deps));
  return undefined;
}
// Bind the installed Router conditional validator/deps/loader types without reparsing in Page.
export const Route = createFileRoute("/_app/sales/offers/")<
  Register,
  typeof validateOffersSearch,
  ResolveParams<"/">,
  AnyContext,
  AnyContext,
  OffersSearch,
  typeof offersLoader
>({
  component: OffersPage,
  errorComponent: AppErrorBoundary,
  loader: offersLoader,
  loaderDeps: offersLoaderDeps,
  pendingComponent: OffersPending,
  staticData: {meta: {breadcrumbs: {hide: true}}},
  validateSearch: validateOffersSearch,
});
